window.addEventListener("load", function(){
  if(document.getElementById("tab-active")){
    document.getElementById("tab-active").click(); 
  }
  headingHomeToggle();
  disableHashNavLinks();
  changeVariantLabel();
});

function openTab(evt, tab) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tab-button");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tab).style.display = "block";
  evt.currentTarget.className += " active";
}

function headingHomeToggle(){
  const homepageImage = document.querySelector("a.homepage_image");
  if(homepageImage){
    window.addEventListener("scroll", function(){
      let header = document.querySelector("sticky-header");
      let hero = document.querySelector("#MainContent").querySelector("section");
      if(hero && this.scrollY > (hero.offsetHeight*0.5)){
        header.classList.remove("homepage-hero-visible");
      }else{
        header.classList.add("homepage-hero-visible");
      }
    });
  }
}

function disableHashNavLinks(){
  var lv_2_links = document.querySelectorAll(".mega-menu .mega-menu__link--level-2");
  lv_2_links.forEach((lv_2) => {
    lv_2.addEventListener("click", function(e){
      if(this.classList.contains("disabled_link")){
        e.preventDefault();
      }
    });
  });
}

function changeVariantLabel(){
  const variantLabels = document.querySelectorAll(".variant-change-label");
  const productForm = document.querySelector("product-form form");
  let productsJson;
  if(variantLabels && productForm){
    document.querySelectorAll("variant-radios script").forEach(script => {
      if(script.type == "application/json"){
        productsJson = JSON.parse(script.textContent);
      }
    });
    if(productsJson){
      productForm.addEventListener("change", function(){
        let variantID = productForm.querySelector("input[name='id']");
        if(variantID.value){
          let selectedProduct = null;
          productsJson.forEach(productJson => {
            if(productJson.id == variantID.value){
              selectedProduct = productJson;
            }
          });
          if(selectedProduct !== null){
            selectedProduct.options.forEach((option, index) => {
              variantLabels[index].innerHTML = option;
            });
          }
        }
      });
    }
  }
}